<template>
    <div class="formgrid grid ">

        <div class="col-12">
            <IslemYapiliyor v-if="IslemYapiliyor" />
        </div>
        <div class="col-12">
            <div class="grid">
                <div class="col-6">
                    <h2>Diyet</h2>
                </div>

                <div class="col-12">
                    <div class="mb-2">
                        <Button icon="pi pi-plus" class="mb-1 mr-1 ml-1" size="small" severity="success" label="Yeni"
                            @click="_DiyetYeniYemekModal()" />
                        <Button icon="pi pi-plus" class="mb-1 mr-1 ml-1" size="small" severity="danger" label="Öğün Sil"
                            @click="_DiyetOgunSilModal()" />
                        <Button icon="pi pi-plus" class="mb-1 mr-1 ml-1" size="small" severity="contrast"
                            label="Diyet Sil" @click="_DiyetSilModal()" />
                        <Button icon="pi pi-file-export" class="mb-1 mr-1 ml-1" size="small" severity="help"
                            label="Export" @click="_DiyetExport()" />
                    </div>
                    <BasicDataTable_RowGroup v-if="DataTable_render" :columns="columns" :data="DiyetDetay"
                        v-on:set-child-data="getDataChild" :editbutton="true" group_name="OgunAd"
                        v-on:delete-child-data="deleteDataChild" :deletebutton="true" />
                </div>
            </div>
        </div>
        <!-- YENİ YEMEK -->
        <Dialog v-model:visible="DiyetYeniYemekModal" header="Yeni Yemek Ekle"
            :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '50vw' }" modal>

            <div class="formgrid grid ">
                <div class="field col md:col-6">
                    <label for="OgunAd">Öğün</label>
                    <Select id="Grup" v-model="Yeni_pOgun" :options="OgunListesi" optionLabel="Ad"
                        optionValue="Ogun_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pOgun" class="text-base text-color w-full" />
                </div>
                <div class="col-6"></div>
                <!-- 1 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup1" v-model="Yeni_pTarif_1" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_1" class="text-base text-color w-full"
                        @change="TarifChange_1" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_1">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_1" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_1"
                        :invalid="this.YeniYemekValid.Miktar_1">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 2 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup2" v-model="Yeni_pTarif_2" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_2" class="text-base text-color w-full"
                        @change="TarifChange_2" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_2">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_2" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_2"
                        :invalid="this.YeniYemekValid.Miktar_2">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 3 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">TarifAd</label>
                    <Select id="Grup3" v-model="Yeni_pTarif_3" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_3" class="text-base text-color w-full"
                        @change="TarifChange_3" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_3">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_3" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_3"
                        :invalid="this.YeniYemekValid.Miktar_3">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 4 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">TarifAd</label>
                    <Select id="Grup4" v-model="Yeni_pTarif_4" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_4" class="text-base text-color w-full"
                        @change="TarifChange_4" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_4">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_4" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_4"
                        :invalid="this.YeniYemekValid.Miktar_4">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 5 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup5" v-model="Yeni_pTarif_5" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_5" class="text-base text-color w-full"
                        @change="TarifChange_5" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_5">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_5" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_5"
                        :invalid="this.YeniYemekValid.Miktar_5">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 6 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup6" v-model="Yeni_pTarif_6" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_6" class="text-base text-color w-full"
                        @change="TarifChange_6" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_6">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_6" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_6"
                        :invalid="this.YeniYemekValid.Miktar_6">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 7 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup7" v-model="Yeni_pTarif_7" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_7" class="text-base text-color w-full"
                        @change="TarifChange_7" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_7">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_7" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_7"
                        :invalid="this.YeniYemekValid.Miktar_7">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 8 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup8" v-model="Yeni_pTarif_8" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_8" class="text-base text-color w-full"
                        @change="TarifChange_8" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_8">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_8" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_8"
                        :invalid="this.YeniYemekValid.Miktar_8">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 9 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup9" v-model="Yeni_pTarif_9" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_9" class="text-base text-color w-full"
                        @change="TarifChange_9" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_9">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_9" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_9"
                        :invalid="this.YeniYemekValid.Miktar_9">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>
                <!-- 10 -->
                <div class="field col md:col-4">
                    <label for="TarifAd">Tarif Ad</label>
                    <Select id="Grup10" v-model="Yeni_pTarif_10" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.YeniYemekValid.pTarif_10" class="text-base text-color w-full"
                        @change="TarifChange_10" />
                </div>
                <div class="field col md:col-4">
                    <label for="Yeni_Miktar_10">Miktar</label>
                    <InputNumber v-model="Yeni_Miktar_10" showButtons buttonLayout="horizontal" :step="1" :min="0"
                        :max="9999" fluid class="text-base text-color w-full" :suffix="Yeni_Birim_10"
                        :invalid="this.YeniYemekValid.Miktar_10">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
                <div class="col-4"></div>


            </div>
            <Divider />
            <div class="flex justify-content-end flex-wrap">
                <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
                    @click="this.YeniYemek_handleClick()" autofocus />
                <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
                    @click="this._DiyetYemekMiktarDuzenleModal()" />
            </div>
        </Dialog>
        <!-- YEMEK VE MİKTAR DÜZENLE -->
        <Dialog v-model:visible="DiyetYemekMiktarDuzenleModal" header="Yemek ve Miktar Düzenle"
            :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '25vw' }" modal>

            <div class="formgrid grid ">
                <div class="field col md:col-12">
                    <label for="OgunAd">Öğün</label>
                    <Select id="Grup" v-model="pOgun" :options="OgunListesi" optionLabel="Ad" optionValue="Ogun_rowid"
                        placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true" :invalid="this.Valid.pOgun"
                        class="text-base text-color w-full" />
                </div>
                <div class="field col md:col-12">
                    <label for="TarifAd">TarifAd</label>
                    <Select id="Grup2" v-model="pTarif" :options="TarifListesi" optionLabel="TarifAd"
                        optionValue="Tarif_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.Valid.pTarif" class="text-base text-color w-full" @change="TarifChange" />
                </div>
                <div class="field col md:col-12">
                    <InputNumber v-model="Miktar" showButtons buttonLayout="horizontal" :step="1" :min="0" :max="9999"
                        fluid class="text-base text-color w-full" :suffix="Birim">
                        <template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                        </template>
                        <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                        </template>
                    </InputNumber>
                </div>
            </div>
            <Divider />
            <div class="flex justify-content-end flex-wrap">
                <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
                    @click="this.handleClick()" autofocus />
                <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
                    @click="this._DiyetYemekMiktarDuzenleModal()" />
            </div>
        </Dialog>

        <Dialog v-model:visible="DiyetOgunSilModal" header="Öğün Sil"
            :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '25vw' }" modal>

            <div class="formgrid grid ">
                <div class="field col md:col-12">
                    <label for="OgunAd">Öğün</label>
                    <Select id="Grup" v-model="pOgun" :options="Tanimli_OgunListesi" optionLabel="Ad"
                        optionValue="Ogun_rowid" placeholder="Seçiniz..." checkmark filter :highlightOnSelect="true"
                        :invalid="this.OgunSil_Valid.pOgun" class="text-base text-color w-full" />
                </div>
            </div>
            <Divider />
            <div class="flex justify-content-end flex-wrap">
                <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
                    @click="this.OgunSil_handleClick()" autofocus />
                <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
                    @click="this._DiyetOgunSilModal()" />
            </div>
        </Dialog>

        <ConfirmDialog :visible="ConfirmDialog"></ConfirmDialog>
    </div>
</template>
<script>
import GlobalServis from "../../../../../../../services/GlobalServis";
import BasicDataTable_RowGroup from "../../../../DataTable/BasicDataTable_RowGroup.vue";
export default {
    props: {
        pMusteri: Number
    },
    data() {
        return {
            DiyetYemekMiktarDuzenleModal: false,
            DiyetYeniYemekModal: false,
            DiyetOgunSilModal: false,
            ConfirmDialog: false,
            //--------------------
            DataTable_render: true,
            IslemYapiliyor: false,
            DiyetDetay: [],
            columns: [
                { field: "OgunAd", header: "Ögun Adı" },
                { field: "TarifAd", header: "Tarif Adı" },
                { field: "MiktarBirim", header: "Miktar" },
            ],

            OgunListesi: [],
            Tanimli_OgunListesi: [],
            TarifListesi: [],
            // ---
            pDiyet: 0,
            pDiyetTanim: 0,
            TarifAd: "",
            pTarif: 0,
            OgunAd: "",
            pOgun: 0,
            Miktar: 0,
            Birim: "",
            //----- Yeni Yemek 
            Yeni_pOgun: 0,
            Yeni_pTarif_1: 0, Yeni_Miktar_1: 0, Yeni_Birim_1: '',
            Yeni_pTarif_2: 0, Yeni_Miktar_2: 0, Yeni_Birim_2: '',
            Yeni_pTarif_3: 0, Yeni_Miktar_3: 0, Yeni_Birim_3: '',
            Yeni_pTarif_4: 0, Yeni_Miktar_4: 0, Yeni_Birim_4: '',
            Yeni_pTarif_5: 0, Yeni_Miktar_5: 0, Yeni_Birim_5: '',
            Yeni_pTarif_6: 0, Yeni_Miktar_6: 0, Yeni_Birim_6: '',
            Yeni_pTarif_7: 0, Yeni_Miktar_7: 0, Yeni_Birim_7: '',
            Yeni_pTarif_8: 0, Yeni_Miktar_8: 0, Yeni_Birim_8: '',
            Yeni_pTarif_9: 0, Yeni_Miktar_9: 0, Yeni_Birim_9: '',
            Yeni_pTarif_10: 0, Yeni_Miktar_10: 0, Yeni_Birim_10: '',

            //------

            Valid: {
                pTarif: false,
                pOgun: false,
                Miktar: false,
            },
            YeniYemekValid: {
                pOgun: false,
                pTarif_1: false, Miktar_1: false,
                pTarif_2: false, Miktar_2: false,
                pTarif_3: false, Miktar_3: false,
                pTarif_4: false, Miktar_4: false,
                pTarif_5: false, Miktar_5: false,
                pTarif_6: false, Miktar_6: false,
                pTarif_7: false, Miktar_7: false,
                pTarif_8: false, Miktar_8: false,
                pTarif_9: false, Miktar_9: false,
                pTarif_10: false, Miktar_10: false,
            },
            OgunSil_Valid: {
                pOgun: false,
            },
        }
    },
    methods: {
        getDataChild(getdata_child) {

            this.ResetForm();
            this.DiyetElemanModalDurum = false;
            this.pTarif = getdata_child.data.Tarif_rowid;
            this.pOgun = getdata_child.data.Ogun_rowid;
            this.pDiyet = getdata_child.data.Diyet_rowid;

            let data = {
                pMusteri: this.pMusteri,
                pOgun: getdata_child.data.Ogun_rowid,
                pTarif: getdata_child.data.Tarif_rowid
            };

            GlobalServis.GlobalServis("POST", "GetDiyetOgunDetayInfo", data).then((res) => {
                if (res.status == 200) {
                    this.pTarif = res.data[0].pTarif;
                    this.pOgun = res.data[0].pOgun;
                    this.Miktar = res.data[0].Miktar;
                    this.Birim = res.data[0].BirimAd;

                    this.DiyetYemekMiktarDuzenleModal = true;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        },
        deleteDataChild(deleteData_child) {
            let pTarif = deleteData_child.data.Tarif_rowid;
            let pOgun = deleteData_child.data.Ogun_rowid;
            let pDiyetTanim = this.DiyetDetay[0].DiyetTanim_rowid;

            this.$confirm.require({
                message: ' Yemek silinecektir. ',
                header: 'Emin misin ?',
                icon: 'pi pi-question-circle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Hayır',
                acceptLabel: 'Evet',
                accept: () => {
                    this.IslemYapiliyor = true;
                    let data = {
                        pDiyetTanim: pDiyetTanim,
                        pMusteri: this.pMusteri,
                        pOgun: pOgun,
                        pTarif: pTarif,
                    };
                    GlobalServis.GlobalServis("POST", "DeleteDiyetTarif", data).then((res) => {
                        if (res.status == 200) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Başarılı",
                                detail: "Yemek silinmiştir.",
                                life: 3000,
                            });
                            this.Refresh();
                        } else if (res.response.status === 999) {
                            this.$toast.add({
                                severity: "warn",
                                summary: "Uyarı",
                                detail: res.response.data,
                                life: 3000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Hata",
                                detail: "Hata oldu",
                                life: 3000,
                            });
                        }
                    }).then(() => {
                        this.IslemYapiliyor = false;
                    });

                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Red', detail: 'İptal Edildi', life: 3000 });
                }
            });


        },
        handleClick() { // update
            if (this._FormCheck()) { return; }
            this.IslemYapiliyor = true;

            let data = {
                pMusteri: this.pMusteri,
                pDiyetTanim: this.pDiyetTanim,
                pDiyet: this.pDiyet,
                pTarif: this.pTarif,
                pOgun: this.pOgun,
                Miktar: this.Miktar,
            };

            GlobalServis.GlobalServis("POST", "UpdateDiyet", data).then((res) => {
                if (res.status == 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Başarılı",
                        detail: "Diyet düzenlemiştir",
                        life: 3000,
                    });
                    this.Refresh();
                    this._DiyetYemekMiktarDuzenleModal();
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
                this.IslemYapiliyor = false;
            });

        },
        YeniYemek_handleClick() {
            if (this._YeniYemekFormCheck()) { return; }
            this.IslemYapiliyor = true;

            let data = {
                pMusteri: this.pMusteri,
                pDiyetTanim: this.pDiyetTanim,
                pDiyet: this.pDiyet,
                pOgun: this.Yeni_pOgun,
                TarifList: [],
            };

            for (let i = 1; i <= 10; i++) {
                const tarif = this[`Yeni_pTarif_${i}`];
                const miktar = this[`Yeni_Miktar_${i}`];
                if (tarif !== 0 && tarif != null) {
                    const existingIndex = data.TarifList.findIndex(item => item.pTarif === tarif);
                    if (existingIndex !== -1) { // Zaten varsa miktarını ekle
                        data.TarifList[existingIndex].Miktar += miktar;
                    } else { // Yoksa yeni ekle
                        data.TarifList.push({ pTarif: tarif, Miktar: miktar });
                    }
                }
            }

            // Yeni Kayıt
            // Eğer diyet no boşsa(Diyet tanımlanmadıysa) uyarı versin(Yeni(manuel) diyet oluştur) yoksa normal diyete eklesin

            if (this.pDiyetTanim == 0) {
                this.$confirm.require({
                    message: 'Kullanıcı adına yeni diyet, ön tanımlı olarak 30 Gün olarak oluşturulacaktır. ',
                    header: 'Yeni Diyet',
                    icon: 'pi pi-question-circle',
                    rejectClass: 'p-button-secondary p-button-outlined',
                    rejectLabel: 'Hayır',
                    acceptLabel: 'Evet',
                    accept: () => {
                        this.IslemYapiliyor = true;

                        GlobalServis.GlobalServis("POST", "SetDiyet", data).then((res) => {
                            if (res.status == 200) {
                                this.$toast.add({
                                    severity: "success",
                                    summary: "Başarılı",
                                    detail: "Diyet oluşturulmuştur",
                                    life: 3000,
                                });
                                this.Refresh();
                                this.IslemYapiliyor = false;
                                this._DiyetYeniYemekModal();
                            } else if (res.response.status === 999) {
                                this.$toast.add({
                                    severity: "warn",
                                    summary: "Uyarı",
                                    detail: res.response.data,
                                    life: 3000,
                                });
                            } else {
                                this.$toast.add({
                                    severity: "error",
                                    summary: "Hata",
                                    detail: "Hata oldu",
                                    life: 3000,
                                });
                            }
                        }).then(() => {
                            this.IslemYapiliyor = false;
                        });

                    },
                    reject: () => {
                        this.$toast.add({ severity: 'error', summary: 'Red', detail: 'İptal Edildi', life: 3000 });
                    }
                });
            } else {
                this.IslemYapiliyor = true;

                GlobalServis.GlobalServis("POST", "SetDiyet", data).then((res) => {
                    if (res.status == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Başarılı",
                            detail: "Diyet oluşturulmuştur",
                            life: 3000,
                        });
                        this.Refresh();
                        this.IslemYapiliyor = false;
                        this._DiyetYeniYemekModal();
                    } else if (res.response.status === 999) {
                        this.$toast.add({
                            severity: "warn",
                            summary: "Uyarı",
                            detail: res.response.data,
                            life: 3000,
                        });
                    } else {
                        this.$toast.add({
                            severity: "error",
                            summary: "Hata",
                            detail: "Hata oldu",
                            life: 3000,
                        });
                    }
                }).then(() => {
                    this.IslemYapiliyor = false;
                });
            }
        },
        OgunSil_handleClick() {
            if (this._OgunSil_FormCheck()) { return; }
            this.$confirm.require({
                message: 'Öğün altında bulunan ilgili tariflerde silinecektir. ',
                header: 'Öğün silinecektir',
                icon: 'pi pi-question-circle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Hayır',
                acceptLabel: 'Evet',
                accept: () => {
                    this.IslemYapiliyor = true;

                    let data = {
                        pMusteri: this.pMusteri,
                        pDiyetTanim: this.pDiyetTanim,
                        pOgun: this.pOgun,
                    };

                    GlobalServis.GlobalServis("POST", "DeleteDiyetOgun", data).then((res) => {
                        if (res.status == 200) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Başarılı",
                                detail: "Öğün silinmiştir.",
                                life: 3000,
                            });
                            this.ConfirmDialog = false;
                            this._DiyetOgunSilModal();
                            this.Refresh();
                        } else if (res.response.status === 999) {
                            this.$toast.add({
                                severity: "warn",
                                summary: "Uyarı",
                                detail: res.response.data,
                                life: 3000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Hata",
                                detail: "Hata oldu",
                                life: 3000,
                            });
                        }
                    }).then(() => {
                        this.IslemYapiliyor = false;
                    });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Red', detail: 'İptal Edildi', life: 3000 });
                }
            });
        },
        _DiyetYemekMiktarDuzenleModal() {
            this.ResetForm();
            this.DiyetYemekMiktarDuzenleModal = !this.DiyetYemekMiktarDuzenleModal;
            this.pDiyetTanim = this.DiyetDetay[0].DiyetTanim_rowid;
        },
        _DiyetYeniYemekModal() {
            this.YeniYemekResetForm();
            this.DiyetYeniYemekModal = !this.DiyetYeniYemekModal;
            if (typeof (this.DiyetDetay[0]) === "undefined") { this.pDiyetTanim = 0; }
            else { this.pDiyetTanim = this.DiyetDetay[0].DiyetTanim_rowid; }
        },
        _DiyetOgunSilModal() {
            this.ResetForm();
            this.DiyetOgunSilModal = !this.DiyetOgunSilModal;
            if (this.DiyetOgunSilModal == true) { this._TanimliOgunListesi(this.DiyetDetay[0].DiyetTanim_rowid) }
            else { this.Tanimli_OgunListesi = []; }
        },
        _DiyetSilModal() {
            let pDiyetTanim = this.DiyetDetay[0].DiyetTanim_rowid;

            this.$confirm.require({
                message: ' Diyet silinecektir. ',
                header: 'Emin misin ?',
                icon: 'pi pi-question-circle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Hayır',
                acceptLabel: 'Evet',
                accept: () => {
                    this.IslemYapiliyor = true;
                    let data = {
                        pDiyetTanim: pDiyetTanim,
                        pMusteri: this.pMusteri,
                    };
                    GlobalServis.GlobalServis("POST", "DeleteDiyet", data).then((res) => {
                        if (res.status == 200) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Başarılı",
                                detail: "Diyet silinmiştir.",
                                life: 3000,
                            });
                            this.Refresh();
                        } else if (res.response.status === 999) {
                            this.$toast.add({
                                severity: "warn",
                                summary: "Uyarı",
                                detail: res.response.data,
                                life: 3000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Hata",
                                detail: "Hata oldu",
                                life: 3000,
                            });
                        }
                    }).then(() => {
                        this.IslemYapiliyor = false;
                    });

                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Red', detail: 'İptal Edildi', life: 3000 });
                }
            });
        },
        Refresh() {
            this.DataTable_render = false;
            this.$nextTick(() => {
                this._DiyetDetay();
                this.DataTable_render = true;
            });
        },
        _DiyetDetay() {
            let data = {
                pMusteri: this.pMusteri,
                pDiyetTanim: this.pDiyetTanim
            };
            GlobalServis.GlobalServis("POST", "GetDiyetDetayInfo", data).then((res) => {
                if (res.status == 200) {
                    // this.DiyetDetay = res.data;
                    this.DiyetDetay = res.data.slice().sort((a, b) => a.Ogun_rowid - b.Ogun_rowid);
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _OgunListesi() {
            GlobalServis.GlobalServis("GET", "GetOgunTablosu", "").then((res) => {
                if (res.status == 200) {
                    this.OgunListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _TarifListesi() {
            GlobalServis.GlobalServis("GET", "GetTarifTablosu", "").then((res) => {
                if (res.status == 200) {
                    this.TarifListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _TanimliOgunListesi(DiyetTanim_rowid) {
            let data = {
                pDiyetTanim: DiyetTanim_rowid
            }
            GlobalServis.GlobalServis("POST", "GetDiyetOgunTablosu", data).then((res) => {
                if (res.status == 200) {
                    this.Tanimli_OgunListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        TarifChange(e) { this.Birim = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_1(e) { this.Yeni_Birim_1 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_2(e) { this.Yeni_Birim_2 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_3(e) { this.Yeni_Birim_3 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_4(e) { this.Yeni_Birim_4 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_5(e) { this.Yeni_Birim_5 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_6(e) { this.Yeni_Birim_6 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_7(e) { this.Yeni_Birim_7 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_8(e) { this.Yeni_Birim_8 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_9(e) { this.Yeni_Birim_9 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        TarifChange_10(e) { this.Yeni_Birim_10 = " " + this.TarifListesi.find(tarif => tarif.Tarif_rowid === e.value).BirimAd; },
        ResetForm() {
            this.TarifAd = "";
            this.pTarif = 0;
            this.OgunAd = "";
            this.pOgun = 0;
            this.Miktar = 0;
            this.Birim = "";
            this.pDiyet = 0;
            this.pDiyetDiyetTanim = 0;
        },
        YeniYemekResetForm() {
            this.Yeni_pOgun = 0;
            this.Yeni_pTarif_1 = 0; this.Yeni_Miktar_1 = 0; this.Yeni_Birim_1 = '';
            this.Yeni_pTarif_2 = 0; this.Yeni_Miktar_2 = 0; this.Yeni_Birim_2 = '';
            this.Yeni_pTarif_3 = 0; this.Yeni_Miktar_3 = 0; this.Yeni_Birim_3 = '';
            this.Yeni_pTarif_4 = 0; this.Yeni_Miktar_4 = 0; this.Yeni_Birim_4 = '';
            this.Yeni_pTarif_5 = 0; this.Yeni_Miktar_5 = 0; this.Yeni_Birim_5 = '';
            this.Yeni_pTarif_6 = 0; this.Yeni_Miktar_6 = 0; this.Yeni_Birim_6 = '';
            this.Yeni_pTarif_7 = 0; this.Yeni_Miktar_7 = 0; this.Yeni_Birim_7 = '';
            this.Yeni_pTarif_8 = 0; this.Yeni_Miktar_8 = 0; this.Yeni_Birim_8 = '';
            this.Yeni_pTarif_9 = 0; this.Yeni_Miktar_9 = 0; this.Yeni_Birim_9 = '';
            this.Yeni_pTarif_10 = 0; this.Yeni_Miktar_10 = 0; this.Yeni_Birim_10 = '';
            this.YeniYemekValidReset();
        },
        YeniYemekValidReset() {
            this.YeniYemekValid.pOgun = false;
            this.YeniYemekValid.pTarif_1 = false; this.YeniYemekValid.Miktar_1 = false;
            this.YeniYemekValid.pTarif_2 = false; this.YeniYemekValid.Miktar_2 = false;
            this.YeniYemekValid.pTarif_3 = false; this.YeniYemekValid.Miktar_3 = false;
            this.YeniYemekValid.pTarif_4 = false; this.YeniYemekValid.Miktar_4 = false;
            this.YeniYemekValid.pTarif_5 = false; this.YeniYemekValid.Miktar_5 = false;
            this.YeniYemekValid.pTarif_6 = false; this.YeniYemekValid.Miktar_6 = false;
            this.YeniYemekValid.pTarif_7 = false; this.YeniYemekValid.Miktar_7 = false;
            this.YeniYemekValid.pTarif_8 = false; this.YeniYemekValid.Miktar_8 = false;
            this.YeniYemekValid.pTarif_9 = false; this.YeniYemekValid.Miktar_9 = false;
            this.YeniYemekValid.pTarif_10 = false; this.YeniYemekValid.Miktar_10 = false;
        },
        _FormCheck() {
            let Check = false;
            if (this.pTarif === 0) {
                this.Valid.pTarif = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Tarif girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.pTarif = false; Check = false; }

            if (this.pOgun === 0) {
                this.Valid.pOgun = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Öğün girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.pOgun = false; Check = false; }


            if (this.Miktar === 0) {
                this.Valid.Miktar = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Miktar girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.Miktar = false; Check = false; }

            return Check;
        },
        _YeniYemekFormCheck() {
            this.YeniYemekValidReset();
            let Check = false;

            for (let i = 1; i <= 10; i++) {
                const tarif = this[`Yeni_pTarif_${i}`];
                const miktar = this[`Yeni_Miktar_${i}`];

                // Eğer tarif seçilmişse ama miktar girilmemişse
                if (tarif !== 0 && (miktar === 0 || miktar == null)) {
                    this.YeniYemekValid[`Miktar_${i}`] = true;
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: `Seçilen Tarif ${i} için miktar girin`,
                        life: 3000,
                    });
                    Check = true;
                    break; // ilk hatada çık
                } else {
                    this.YeniYemekValid[`Miktar_${i}`] = false;
                }
            }

            // Ek kontrol: hiç tarif seçilmemişse uyar
            const enAzBirTarifVarMi = Array.from({ length: 10 }, (_, i) => this[`Yeni_pTarif_${i + 1}`]).some(t => t !== 0);
            if (!enAzBirTarifVarMi) {
                this.YeniYemekValid.pTarif_1 = true; // sadece örnek olarak ilkine işaret koy
                this.$toast.add({
                    severity: "warn",
                    summary: "Uyarı",
                    detail: "En az bir adet tarif seçmelisiniz",
                    life: 3000,
                });
                Check = true;
            }
            return Check;
        },
        _OgunSil_FormCheck() {
            let Check = false;
            if (this.pOgun === 0) {
                this.OgunSil_Valid.pOgun = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Öğün seçiniz.", life: 3000, });
                Check = true;
                return Check;
            } else { this.OgunSil_Valid.pOgun = false; Check = false; }

            return Check;
        },
        _DiyetExport() {
            if (typeof (this.DiyetDetay[0]) === "undefined") {
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Tanımlı diyet bulunamadı.", life: 3000, });
            }
            else if (this.DiyetDetay[0].DiyetTanim_rowid === 0 || this.DiyetDetay[0].DiyetTanim_rowid === null) {
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Tanımlı diyet bulunamadı.", life: 3000, });
            } else {
                this.$router.push({ path: "/Diyetisyen/ExportDiyet", query: { DanisanNo: this.pMusteri } });
            }
        },
        //
    },
    mounted() {
    },
    created() {
        this._DiyetDetay();
        this._OgunListesi();
        this._TarifListesi();
    },
    components: {
        BasicDataTable_RowGroup
    }
};
</script>